import styled from 'styled-components';

import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import TvIcon from '@mui/icons-material/Tv';
import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { HowToWatchPanel } from '~/views/components/howToWatchModal/styles';

const LOGO_MAX_WIDTH = 60;
const LOGO_MAX_HEIGHT = 38;
const ICON_HEIGHT = 20;

export const BroadcasterLogo = styled.img`
    max-height: ${LOGO_MAX_HEIGHT}px;
    max-width: ${LOGO_MAX_WIDTH}px;
`;

export const LogoWrapper = styled.div`
    width: ${LOGO_MAX_WIDTH}px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const BroadcastWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: ${LOGO_MAX_HEIGHT}px;
    background: ${({ theme }) => theme.Surface.primary};
    color: ${({ theme }) => theme.Text.primary};
`;

export const LogoPlaceholder = styled.div`
    height: ${LOGO_MAX_HEIGHT}px;
    width: ${LOGO_MAX_WIDTH}px;
`;

export const LogoTitleWrapper = styled.div`
    ${BaseStyle.Mixins.fontStyles.desktop.body2};
    ${BaseStyle.Mixins.gaps.small}
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const PanelWrapper = styled.a`
    height: 100%;
    cursor: pointer;
`;

export const StyledOpenInNewIcon = styled(OpenInNewIcon)`
    max-height: ${ICON_HEIGHT}px;
    max-width: ${ICON_HEIGHT}px;
    height: ${ICON_HEIGHT}px;
    width: ${ICON_HEIGHT}px;

    fill: ${({ theme }) => theme.Utility.cta};
`;

export const StyledTvIcon = styled(TvIcon)`
    max-height: ${ICON_HEIGHT}px;
    max-width: ${ICON_HEIGHT}px;
    height: ${ICON_HEIGHT}px;
    width: ${ICON_HEIGHT}px;
`;

export const NonLinkBroadcastRow = styled(HowToWatchPanel)`
    border: none;
`;
